import React from 'react';
import { useLocation } from 'react-router-dom';

import { BOOKING } from '@app/utils/booking';
import { pushEvent } from '@app/components/TagManager';

type DeviceType = 'mobile' | 'desktop';

export const useOLBPhoneClick = () => {
	const { pathname } = useLocation();

	const getDeviceType = (): DeviceType => {
		const isMobile = window.matchMedia('(max-width: 768px)').matches;

		return isMobile ? 'mobile' : 'desktop';
	};

	const trackEvent = React.useCallback((event: string, data?: object) => {
		if (!pathname.includes(BOOKING)) {
			return;
		}

		pushEvent(event, {
			deviceType: getDeviceType(),
			...data,
		});
	}, []);

	return {
		trackEvent,
	};
};
